import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface DeleteSubtypeVersionRequest {
  version_id: number;
  subtype_id?: number;
}

export function deleteSubtypeVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'DeleteSubtypeVersion',
    description: 'Deletes a subtype version',
    execute: (data: DeleteSubtypeVersionRequest): Observable<any> => {
      if (!data.version_id) {
        return of({ success: false, error: 'Missing required field: version_id' });
      }
      return componentDataSourceService.http.delete<any>(
        `${environment.apiUrl}/events/subtypes/versions/${data.version_id}`
      ).pipe(
        tap(() => {
          dataSharingService.setData('subtypes_updated', {
            timestamp: Date.now(),
            ...(data.subtype_id && { subtype_id: data.subtype_id })
          });
        }),
        catchError(err => {
          console.error('[DeleteSubtypeVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
